import type { ContentPaths, UseQueryFunctionOptions } from '../../types'
import type { Brand } from '../../types/clients/content'
import type { BlogPostListItem } from '../../types/blog'
import { useQuery, useOpenapi, useCoreConfig } from '#imports'

/**
 * @title useContentClient
 * @see Docs https://content-prod.spilnu.dk/api/documentation
 */
export const useContentClient = () => {
    const { site } = useCoreConfig()

    const client = useOpenapi<ContentPaths>({
        // dedoc/scramble omits `/api` from path types.
        baseUrl: '/gateway/content/api',
        service: 'content'
    })

    function getBlogPosts(options: Omit<UseQueryFunctionOptions<BlogPostListItem[]>, 'key'> = {}) {
        return useQuery<BlogPostListItem[]>(async ({ signal }) => {
            const { data } = await client.GET('/v1/public/blog/posts', {
                signal,
                params: { query: { brand: site.brand as unknown as Brand } },
            })

            return data ?? []
        }, {
            ...options,
            key: 'content:blog-posts',
        })
    }

    return {
        client,

        getBlogPosts,
    }
}
